<template>
  <div class="row">
    <div class="col-3">
      <table class="table table-bordered table-striped table-sm">
        <tr>
          <th class="align-middle text-center" style="background-color: #EEE8AA; width: 110px;">Gold</th>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': gold_color_bid }">Bid:<br/>{{currentSpotPrice('GOLD').bid | currency}}</td>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': gold_color_ask }">Ask:<br/>{{currentSpotPrice('GOLD').ask | currency}}</td>
        </tr>
      </table>
    </div>
    <div class="col-3">
      <table class="table table-bordered table-striped table-sm">
        <tr>
          <th class="align-middle text-center" style="background-color: #BCC6CC; width: 110px;">Silver</th>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': silver_color_bid }">Bid:<br/>{{currentSpotPrice('SILV').bid | currency}}</td>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': silver_color_ask }">Ask:<br/>{{currentSpotPrice('SILV').ask | currency}}</td>
        </tr>
      </table>
    </div>
    <div class="col-3">
      <table class="table table-bordered table-striped table-sm">
        <tr>
          <th class="align-middle text-center" style="background-color: #E5E4E2; width: 110px;">Platinum</th>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': platinum_color_bid }">Bid:<br/>{{currentSpotPrice('PLAT').bid | currency}}</td>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': platinum_color_ask }">Ask:<br/>{{currentSpotPrice('PLAT').ask | currency}}</td>
        </tr>
      </table>
    </div>
    <div class="col-3">
      <table class="table table-bordered table-striped table-sm">
        <tr>
          <th class="align-middle text-center" style="background-color: #CED0DD; width: 110px;">Palladium</th>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': palladium_color_bid }">Bid:<br/>{{currentSpotPrice('PALL').bid | currency}}</td>
          <td class="align-middle text-center" style="background-color: #FFFFFF" v-bind:style="{ 'color': palladium_color_ask }">Ask:<br/>{{currentSpotPrice('PALL').ask | currency}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'spot-prices',
    data () {
      return {
        spot_prices: null,
        gold_color_bid: 'black',
        gold_color_ask: 'black',
        silver_color_bid: 'black',
        silver_color_ask: 'black',
        platinum_color_bid: 'black',
        platinum_color_ask: 'black',
        palladium_color_bid: 'black',
        palladium_color_ask: 'black'
      }
    },
    methods: {
      getColor (newVal, oldVal) {
        if (oldVal && newVal > oldVal) {
          return 'green'
        } else if (oldVal && newVal < oldVal) {
          return 'red'
        } else {
          return 'black'
        }
      },
      currentSpotPrice: function (symbol) {
        if (this.spot_prices && this.spot_prices[symbol]) {
          return this.spot_prices[symbol]
        } else {
          return {bid: null, ask: null}
        }
      }
    },
    watch: {
      spot_prices: function (newVal, oldVal) {
        if (oldVal) {
          this.gold_color_bid = this.getColor(newVal['GOLD'].bid, oldVal['GOLD'].bid)
          this.gold_color_ask = this.getColor(newVal['GOLD'].ask, oldVal['GOLD'].ask)
          this.silver_color_bid = this.getColor(newVal['SILV'].bid, oldVal['SILV'].bid)
          this.silver_color_ask = this.getColor(newVal['SILV'].ask, oldVal['SILV'].ask)
          this.platinum_color_bid = this.getColor(newVal['PLAT'].bid, oldVal['PLAT'].bid)
          this.platinum_color_ask = this.getColor(newVal['PLAT'].ask, oldVal['PLAT'].ask)
          this.palladium_color_bid = this.getColor(newVal['PALL'].bid, oldVal['PALL'].bid)
          this.palladium_color_ask = this.getColor(newVal['PALL'].ask, oldVal['PALL'].ask)
        }
      }
    },
    created () {
      this.$bus.$on('spot-price', ($event) => {
        if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
          this.spot_prices = $event
        }
      })
    },
    beforeMount () {
      this.$bus.$emit('request-spot-price')
    }
  }
</script>



// WEBPACK FOOTER //
// SpotPrices.vue?2b0d3bb0